export default "__VITE_ASSET__BFQiRxq3__"